import { PublicKey } from "@solana/web3.js";

export const BONFIDA_STAKING_PROGRAM_ID = new PublicKey("DwUC9SbgC2icQS9qEUzYaC58GkojH3LU7mccZuezgbQ5");
export const FIDA_MINT = new PublicKey("EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp");
